import { useMemo } from 'react';
import { useQuery } from '../../../../shared/utils/useQueryParam';
import { parseBooleanFlag, trimToEmpty } from '../../../../shared/utils/strings';
import {
    mapBpChannelToOrbitChannel,
    OrbitChannelEnum,
} from '../channelForm/formData';

const BP_PARAM = {
    callId: 'callId',
    channel: 'channel',
    documentType: 'documentType',
    document: 'document',
    habeasData: 'habeasData',
} as const;

export interface OrbitBpParams {
    callId: string;
    orbitChannel: OrbitChannelEnum | undefined;
    hasCallIdFromUrl: boolean;
    documentType: string;
    document: string;
    habeasData: boolean;
    hasHabeasDataFromUrl: boolean;
}

export const useOrbitBpParams = (): OrbitBpParams => {
    const query = useQuery();
    const rawCallId = trimToEmpty(query.get(BP_PARAM.callId));
    const rawChannel = trimToEmpty(query.get(BP_PARAM.channel));
    const rawDocumentType = trimToEmpty(query.get(BP_PARAM.documentType));
    const rawDocument = trimToEmpty(query.get(BP_PARAM.document));
    const rawHabeasData = trimToEmpty(query.get(BP_PARAM.habeasData));

    return useMemo<OrbitBpParams>(
        () => ({
            callId: rawCallId,
            orbitChannel: mapBpChannelToOrbitChannel(rawChannel),
            hasCallIdFromUrl: rawCallId.length > 0,
            documentType: rawDocumentType.toUpperCase(),
            document: rawDocument,
            habeasData: parseBooleanFlag(rawHabeasData),
            hasHabeasDataFromUrl: rawHabeasData.length > 0,
        }),
        [rawCallId, rawChannel, rawDocumentType, rawDocument, rawHabeasData]
    );
};
